import { useTranslation } from 'react-i18next';

import { useOutletContext, useRouteLoaderData } from '@remix-run/react';
import { ProprietaryFooter as SharedProprietaryFooter } from '@shared/dream-components';

import type { OutletContext } from '~/interfaces/outlet_context';
import type { RootLoaderData } from '~/root';

import type { ProprietaryFooterProps } from './ProprietaryFooter.types';

const ProprietaryFooter = ({
  node,
  showPoweredByBeehiiv = true,
  shouldRenderOverContent = false,
}: ProprietaryFooterProps) => {
  const { site } = useRouteLoaderData('root') as RootLoaderData;
  const { publicationName, publicationCopyrightText, publicationLogoUrl, publicationUtmSource } =
    useOutletContext<OutletContext>();
  const { t } = useTranslation();

  if (!site.publication.beehiiv_branding) return null;

  const year = new Date().getFullYear();
  const displayName = publicationCopyrightText || publicationName || '';

  return (
    <SharedProprietaryFooter
      backgroundColor={node?.attrs?.backgroundColor}
      textColor={node?.attrs?.color}
      data={{
        publicationName: publicationName || '',
        publicationLogoUrl: publicationLogoUrl || site.publication.logo?.url,
        publicationUtmSource: publicationUtmSource || site.publication.footer_referral_utm_source,
        showBeehiivBranding: site.publication.beehiiv_branding,
        translations: {
          copyrightText: t('footer.copyright_simple', { year, name: displayName }),
          poweredByBeehiiv: t('shared.cta.powered_by_beehiiv') || 'Powered by beehiiv',
        },
      }}
      showPoweredByBeehiiv={showPoweredByBeehiiv}
      shouldRenderOverContent={shouldRenderOverContent}
    />
  );
};

export { ProprietaryFooter };
